import { useState, useEffect } from 'react';
import Form, { InputType } from '../../lib/Formik';
import { Dialog } from '@material-ui/core';
import AccessibleDialog from '../../lib/AccessibleDialog';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Grid } from '@material-ui/core';
import * as yup from 'yup';
import en from '../../lang/en-us';

const {
    signUp: { form, switchActions },
} = en;

import { FormikHelpers, useFormik } from 'formik';
import { connect } from 'react-redux';
import { signup } from '../../redux-store/actions/login';
import { SignupPayload, SignupResponse } from '../../redux-store/types/login';
import { ResponseBody } from '../../redux-store/middleware';
import ToggleTabs, { OFF, ON } from '../../lib/ToggleTabs';
import { addDialCode, emailRegex, OTP_ACTIONS, panRegex } from '../../utils/constants';
import Captcha from './Captcha';
export interface SignUpFormValues {
    pan?: string;
    pekrn?: string;
    mobile: string;
    email: string;
    agreeTerms?: boolean;
}

const AgreeTerms = (props: any) => {
    const [show, setShow] = useState<boolean>(false);
    const [checkboxAction, setCheckboxActive] = useState<boolean>(props.value);
    const onChange = () => {
        let val = !checkboxAction;
        props.updateValue(val);
        setCheckboxActive(val);
    };
    useEffect(() => {
        setCheckboxActive(props.value);
    }, [props.value]);
    return (
        <>
            <FormControlLabel
                className={props.error ? 'error' : ''}
                control={<Checkbox onChange={onChange} checked={checkboxAction} />}
                label={
                    <>
                        {en.signUp.form.Policies.title}{' '}
                        <a
                            href="/links/terms-of-use"
                            target="_blank"
                            rel="noopener noreferrer"
                            role="link"
                            tabIndex={0}
                            aria-label="Terms & Conditions - Opens in new tab"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    window.open('/links/terms-of-use', '_blank');
                                }
                            }}
                        >
                            {en.signUp.form.Policies.TandC}
                        </a>
                    </>
                }
                {...props}
            />
            <AccessibleDialog
                fullWidth
                maxWidth={'md'}
                open={show}
                aria-labelledby="signup-terms-modal"
                onClose={() => setShow(false)}
            >
                <div className="signup-terms-modal">
                    <button
                        type="button"
                        aria-label="Close modal"
                        onClick={() => setShow(!show)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                setShow(!show);
                            }
                        }}
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                        }}
                    >
                        <img src="/images/close-black.svg" alt="Close modal" />
                    </button>
                    <h3 id="signup-terms-modal"> {en.signUp.form.Policies.TandC}</h3>
                    <p>{en.signUp.form.TermsAndCond.title1}</p>
                    <p>{en.signUp.form.TermsAndCond.title2}</p>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <p>{en.signUp.form.TermsAndCond.title2}</p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <p>{en.signUp.form.TermsAndCond.title2}</p>
                        </Grid>
                    </Grid>
                </div>
            </AccessibleDialog>
        </>
    );
};

const staticFields = {
    mobile: '',
    email: '',
    agreeTerms: false,
    captcha: null,
};

const panInitValues: SignUpFormValues = {
    pan: '',
    ...staticFields,
};

const pekrnInitValues: SignUpFormValues = {
    pekrn: '',
    ...staticFields,
};

function SignUpPage(props: any) {
    const [signUpType, setType] = useState(OFF);
    const [signUpWith, setWith] = useState(OFF);

    const switchTabs = (e: any) => {
        panFormik.resetForm();
        pekrnFormik.resetForm();
        setType(e.target.checked ? ON : OFF);
    };

    const switchWithTabs = (e: any) => {
        panFormik.setValues({
            ...panFormik.values,
            mobile: '',
            email: '',
        });
        pekrnFormik.setValues({
            ...pekrnFormik.values,
            mobile: '',
            email: '',
        });
        setWith(e.target.checked ? ON : OFF);
    };

    const panFormFields: Partial<InputType>[] = [
        {
            label: en.signUp.form.pan.label,
            name: 'pan',
            type: 'text',
        },
        {
            component: ToggleTabs,
            name: 'toggleTabs',
            extraProps: {
                value: signUpWith,
                updateValue: switchWithTabs,
                offText: 'Mobile',
                onText: 'Email',
                extraClass: 'mobile-email',
            },
        },
        {
            label: signUpWith === OFF ? en.signUp.form.mobile.label : en.signUp.form.email.label,
            name: signUpWith === OFF ? 'mobile' : 'email',
            type: 'text',
        },
        {
            component: Captcha,
            name: 'captcha',
        },
        {
            component: AgreeTerms,
            name: 'agreeTerms',
        },
    ];

    const pekrnFormFields: Partial<InputType>[] = [
        {
            label: en.signUp.form.pekrn.label,
            name: 'pekrn',
            type: 'text',
        },
        {
            component: ToggleTabs,
            name: 'toggleTabs',
            extraProps: {
                value: signUpWith,
                updateValue: switchWithTabs,
                offText: 'Mobile',
                onText: 'Email',
                extraClass: 'mobile-email',
            },
        },
        {
            label: signUpWith === OFF ? en.signUp.form.mobile.label : en.signUp.form.email.label,
            name: signUpWith === OFF ? 'mobile' : 'email',
            type: 'text',
        },
        {
            component: Captcha,
            name: 'captcha',
        },
        {
            component: AgreeTerms,
            name: 'agreeTerms',
        },
    ];

    const panValidation = yup.object({
        pan: yup
            .string()
            .required(form.pan.validations.emptyError)
            .length(10, form.pan.validations.regexError)
            .test('regex', form.pan.validations.individualPan, (val) =>
                panRegex.test((val || '').toUpperCase()),
            ),
        mobile:
            signUpWith === OFF
                ? yup
                      .string()
                      .required(form.mobile.validations.emptyError)
                      .matches(/^[]?[0-9]\d{9}$/, form.mobile.validations.regexError)
                : yup.string().default(''),
        email:
            signUpWith === ON
                ? yup
                      .string()
                      .required(form.email.validations.emptyError)
                      .matches(emailRegex, form.email.validations.regexError)
                : yup.string().default(''),
        agreeTerms: yup.boolean().oneOf([true], 'Please accept terms and conditions'),
        captcha: yup.string().required('Captcha is Required').nullable(),
    });

    const pekrnValidation = yup.object({
        pekrn: yup
            .string()
            .required(form.pekrn.validations.emptyError)
            .min(9, form.pekrn.validations.regexError)
            .max(12, form.pekrn.validations.regexError),
        mobile:
            signUpWith === OFF
                ? yup
                      .string()
                      .required(form.mobile.validations.emptyError)
                      .matches(/^[]?[0-9]\d{9}$/, form.mobile.validations.regexError)
                : yup.string().default(''),
        email:
            signUpWith === ON
                ? yup
                      .string()
                      .required(form.email.validations.emptyError)
                      .matches(emailRegex, form.email.validations.regexError)
                : yup.string().default(''),
        agreeTerms: yup.boolean().oneOf([true], 'Please accept terms and conditions'),
        captcha: yup.string().required('Captcha is Required').nullable(),
    });

    const onSignUp = async (
        values: SignUpFormValues,
        actions: FormikHelpers<SignUpFormValues>,
    ): Promise<void> => {
        const { pan = '', pekrn = '', mobile = '', email = '' } = values;
        const action = OTP_ACTIONS.register;
        const payload: SignupPayload = {
            pan: pan.toUpperCase(),
            pekrn: pekrn.toUpperCase(),
            mobile: mobile && addDialCode(mobile),
            email,
            action,
        };
        try {
            const { body }: ResponseBody<SignupResponse> = await props.signup(payload);
            props.history.push(`signup-otp`, { ...body, mobile, email, pan, pekrn, action });
        } catch (err: any) {
            alert(err.message);
        }
        actions.setSubmitting(false);
    };

    const panFormik = useFormik({
        initialValues: panInitValues,
        onSubmit: onSignUp,
        enableReinitialize: true,
        validationSchema: panValidation,
    });

    const pekrnFormik = useFormik({
        initialValues: pekrnInitValues,
        onSubmit: onSignUp,
        enableReinitialize: true,
        validationSchema: pekrnValidation,
    });

    return (
        <div className="signup-page" style={{ paddingTop: 0 }}>
            <h3
                className="text-center"
                style={{
                    fontSize: '21px',
                    lineHeight: 'normal',
                    marginTop: '0.67em',
                    marginBottom: '14px',
                }}
            >
                {en.signUp.signupText}
            </h3>
            <ToggleTabs
                value={signUpType}
                updateValue={switchTabs}
                offText={switchActions.sigUpWithPAN}
                onText={switchActions.sigUpWithPEKRN}
            />
            {signUpType === OFF ? (
                <Form
                    ui={panFormFields}
                    submitButtonLabel={en.signUp.form.action.button}
                    formik={panFormik}
                ></Form>
            ) : (
                <Form
                    ui={pekrnFormFields}
                    submitButtonLabel={en.signUp.form.action.button}
                    formik={pekrnFormik}
                ></Form>
            )}
        </div>
    );
}

export default connect(null, { signup })(SignUpPage);
